module.exports = __webpack_public_path__ + "img/hongdian.009cb9e0.png";